import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import { Stack } from "@mui/material";
import { TextField } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { FormTextField, FormDateTimePicker } from "../../../../GlobalComponents/form-components";
import { useCreateListMutation } from "../list-manager/api";
import { useAuthSession } from "../../../../Auth";
import { useQueryClient } from "@tanstack/react-query";
import LinearProgress from '@mui/material/LinearProgress';
import ErrorHandler from "../list-manager/error-handling/ErrorHandler";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { AxiosError } from "axios";

dayjs.extend(utc);

type CreateListFormData = {
  name: string;
  // end_utc?: Date | null;
  start_utc?: Date | null;
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function CreateListModal() {
  const queryClient = useQueryClient();
  const methods = useForm<CreateListFormData>();
  const [open, setOpen] = React.useState(false);
  const { mutate, isPending, isSuccess, reset: resetMutation, error } = useCreateListMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contact-lists"] });
    },
  });
  const { name: user_name } = useAuthSession();

  console.log("error", error)

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    methods.reset();
    resetMutation();
  };

  const onSubmit = (data: CreateListFormData) => {
    const body: PostListBody = {
      name: data.name,
      created_by: user_name,
      start_utc: data.start_utc
        ? dayjs(data.start_utc).utc().toISOString()
        : dayjs().utc().toISOString(),
    };

    console.log("submit body", body)
    

    mutate(body);
  };

  return (
    <FormProvider {...methods}>
      <React.Fragment>
        <IconButton aria-label="add" onClick={handleClickOpen}>
          <AddIcon />
        </IconButton>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Create Dialing List
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Stack width={420} padding={3} paddingTop={1} alignItems="center">
              <ErrorHandler error={error as AxiosError} />
              {isPending ? (
                <Stack paddingTop={2} width="100%">
                  <LinearProgress sx={{ width: "100%" }} />
                </Stack>
              ) : isSuccess ? (
                <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                  List Created Successfully
                </Typography>
              ) : (
                <Stack gap={3}>
                  <Stack gap={1}>
                    <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                      List Name
                    </Typography>
                    <FormTextField required name="name" placeholder="Enter List Name" />
                  </Stack>
                  <Stack gap={1}>
                    <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                      Start Date (Optional - Will start immediately if not
                      provided)
                    </Typography>
                    <FormDateTimePicker name="start_utc" />
                  </Stack>
                  {/* <Typography>End Date (Optional)</Typography> */}
                  {/* <FormDateTimePicker name="end_utc" /> */}
                </Stack>
              )}
            </Stack>
          </DialogContent>
          {isSuccess ? (
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          ) : (
            <DialogActions>
              <Button onClick={handleClose} disabled={isPending}>
                Cancel
              </Button>
              <Button
                autoFocus
                onClick={methods.handleSubmit(onSubmit)}
                disabled={isPending}
              >
                Create List
              </Button>
            </DialogActions>
          )}
        </BootstrapDialog>
      </React.Fragment>
    </FormProvider>
  );
}
